export default "__VITE_ASSET__mGCMUENb__"